import { IPromise, IScope } from 'angular'
import { $q } from '../../../ng-compat/imports'
import { PartialPaymentTypeName } from './PartialPaymentModal'

interface PartialPaymentOptions {
  availableCredit: number
  paymentTypeName: PartialPaymentTypeName
}

/**
 * Controller class for the partial payment modal component
 *
 * @class PartialPaymentModalController
 */
export class PartialPaymentModalController {
  public readonly close: () => void
  public paymentTypeName: PartialPaymentTypeName
  public availableCredit: number
  private readonly internalClose: (val: IPromise<boolean>) => void

  constructor(
    $scope: IScope,
    close: (val: IPromise<boolean>) => void,
    public options: PartialPaymentOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'

    this.internalClose = close
    this.close = () => this.internalClose($q.reject())

    this.paymentTypeName = options.paymentTypeName
    this.availableCredit = options.availableCredit

    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
